import { render, staticRenderFns } from "./DetailLeftTop.vue?vue&type=template&id=27575c86&scoped=true&name=detailLeftTop&"
import script from "./DetailLeftTop.vue?vue&type=script&lang=js&"
export * from "./DetailLeftTop.vue?vue&type=script&lang=js&"
import style0 from "./DetailLeftTop.vue?vue&type=style&index=0&id=27575c86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27575c86",
  null
  
)

export default component.exports